import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';

export const getProductPrice = (product: CartLineItem) => {
  const prices = product?.variant?.prices;
  const regularPrice = prices?.regular?.value?.centAmount;
  const offerPrice = prices?.offer?.value?.centAmount;

  return offerPrice ?? regularPrice ?? 0;
};
